import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import { Stack } from "@mui/material";
import "./SequencesTable.css";

export default function SequencesTableSkeleton() {
  const tableheaders = [
    { id: 0, label: "Edit" },
    { id: 1, label: "Cron ID" },
    { id: 2, label: "Queue Name" },
    { id: 3, label: "Frequency" },
    { id: 4, label: "Last Run" },
    { id: 5, label: "Status" },
    { id: 6, label: "Process Count" },
    { id: 7, label: "More Info" },
  ];

  // Number of skeleton rows to display
  const skeletonRows = 10;

  return (
    <>
      {/* Skeleton for Filters */}
      <Box sx={{ mb: 2, p: 2, backgroundColor: "#fff", borderRadius: 1 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Skeleton variant="rectangular" width={200} height={40} />
          <Skeleton variant="rectangular" width={200} height={40} />
          <Skeleton variant="rectangular" width={200} height={40} />
          <Skeleton variant="rectangular" width={150} height={40} />
        </Stack>
      </Box>

      <TableContainer
        className="chainsTableWrap"
        component={Paper}
        sx={{ maxHeight: 800 }}
      >
        <Table aria-label="skeleton table" size="small" stickyHeader>
          <TableHead sx={{ "& > *": { borderBottom: "unset" } }}>
            <TableRow>
              {tableheaders.map((header) => (
                <TableCell key={header.id}>
                  <Skeleton variant="text" width="80%" height={24} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: skeletonRows }).map((_, rowIndex) => (
              <TableRow key={rowIndex} sx={{ "& > *": { borderBottom: "unset" } }}>
                {/* Edit Icon */}
                <TableCell>
                  <Skeleton variant="circular" width={32} height={32} />
                </TableCell>
                
                {/* Cron ID */}
                <TableCell align="left">
                  <Skeleton variant="text" width={40} height={20} />
                </TableCell>
                
                {/* Queue Name */}
                <TableCell align="left">
                  <Skeleton variant="text" width={150} height={20} />
                </TableCell>
                
                {/* Frequency */}
                <TableCell align="left">
                  <Skeleton variant="text" width={180} height={20} />
                </TableCell>
                
                {/* Last Run */}
                <TableCell align="left">
                  <Skeleton variant="text" width={130} height={20} />
                </TableCell>
                
                {/* Status */}
                <TableCell align="left">
                  <Skeleton variant="rectangular" width={100} height={30} sx={{ borderRadius: 1 }} />
                </TableCell>
                
                {/* Process Count */}
                <TableCell align="left">
                  <Skeleton variant="text" width={30} height={20} />
                </TableCell>
                
                {/* More Info Icon */}
                <TableCell align="left">
                  <Skeleton variant="circular" width={32} height={32} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        
        {/* Skeleton for Pagination */}
        <Stack
          spacing={1}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ p: 2 }}
        >
          <Skeleton variant="text" width={150} height={32} />
          <Skeleton variant="rectangular" width={300} height={32} sx={{ borderRadius: 1 }} />
          <Skeleton variant="text" width={150} height={32} />
        </Stack>
      </TableContainer>
    </>
  );
}